import React, { useContext, useEffect, useState } from 'react'
import { themeContext } from '../../Context/ThemeContext';
import styles from "../../asset/css/homePage.module.css";
import { Images } from '../../data/Images';
export default function ThemeImg({ dynamicPath, dynamicClass }) {
    const { themeValue, handleThemeChange } = useContext(themeContext);
    const [currentImgPath, setCurrentImgPath] = useState({})

    useEffect(() => {
        if (themeValue) {
            const LightThemeImgs = {
                homeHandImg: require("../../asset/images/nexus/handImgLightTheme.png"),
                tokenChartImg: require("../../asset/images/nexus/homeChart1LightTheme.png"),
                netWorkChart: require("../../asset/images/nexus/homeChart2LightTheme.png"),
                footerNexusLogo: require("../../asset/images/nexus/footerLightThemeNexusLogo.png"),
                themeCoinImg1: require("../../asset/images/nexus/lightThemeCoinImg.png"),
                // themeCoinImg1: require("../../asset/images/nexus/lightThemeCoinGif.gif"),
            }
            setCurrentImgPath(LightThemeImgs);
        } else {
            const DarkThemeImgs = {
                homeHandImg: require("../../asset/images/nexus/handImgDarkTheme.png"),
                tokenChartImg: require("../../asset/images/nexus/homeChart1DarkTheme.png"),
                netWorkChart: require("../../asset/images/nexus/homeChart2DarkTheme.png"),
                footerNexusLogo: require("../../asset/images/nexus/footerDarkThemeNexusLogo.png"),
                themeCoinImg1: require("../../asset/images/nexus/darkThemeCoinImg.png"),
            }
            setCurrentImgPath(DarkThemeImgs);
        }
    }, [themeValue]);

    return (
        // <img className={dynamicClass ? styles[dynamicClass] : ""} src={currentImgPath[dynamicPath]} alt="hand image" />
        <img src={currentImgPath[dynamicPath]} alt="hand image" />
    )
}

export const ImageComponent = ({ themeImgSrc, staticImgSrc, className, moduleClass, moduleStyle, alt }) => {
    const { themeValue, handleThemeChange } = useContext(themeContext);
    if (staticImgSrc) {
        return (<img
            src={Images[staticImgSrc]}
            className={className ? className : moduleStyle ? moduleStyle[moduleClass] : ""} alt={alt} />)
    } else {
        return (<img
            src={themeValue ? Images[`light_${themeImgSrc}`] : Images[`dark_${themeImgSrc}`]}
            className={className || ""} alt={alt} />)
    }
}
